import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/styles.scss';export default {
  "main": "_main_19tp9_1",
  "resource": "_resource_19tp9_13",
  "iconBox": "_iconBox_19tp9_24",
  "icon": "_icon_19tp9_24",
  "openedIcon": "_openedIcon_19tp9_41",
  "row": "_row_19tp9_45",
  "avatar": "_avatar_19tp9_53",
  "col": "_col_19tp9_58",
  "name": "_name_19tp9_67",
  "profession": "_profession_19tp9_73",
  "recordList": "_recordList_19tp9_78",
  "controls": "_controls_19tp9_82"
};